<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="file_033">BUMBLEBEE</a></h3><a id="file_033">
<p class="noindent"><strong>1.</strong> Roll a piece of black wool into a 1″ (2.5 cm) ball. Needle the surface. This will be the bumblebee’s body.</p>
<p class="image"><img alt="Image" src="images/f0014-01.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_033.vue?13af8640